module.exports = __webpack_public_path__ + "img/dd2.8bba91ea.jpg";